import { Injectable, Injector } from '@angular/core';

import { CustomHttpClientService, PaymentsAuthenticationService } from '@payments/common-utils';

import { UrlConstants } from '../config/urlConstants';

@Injectable({
    providedIn: 'root',
})
export class BetslipQdAuthenticationService extends PaymentsAuthenticationService {
    constructor(customHttpClientService: CustomHttpClientService, injector: Injector) {
        super(customHttpClientService, injector);
    }
    override authenticateUser(sessionInfo: any) {
        return super.authenticateUser(sessionInfo, UrlConstants.AUTHENTICATE_URI);
    }
}
